/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateAccountInput = {
  id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  ownerId?: string | null,
  name: string,
  address?: string | null,
  city?: string | null,
  state?: string | null,
  postalCode?: string | null,
  accountType?: AccountType | null,
  accountStatus?: AccountStatus | null,
  accountSize?: AccountSize | null,
  customerId?: string | null,
};

export enum AccountType {
  Individual = "Individual",
  Agency = "Agency",
}


export enum AccountStatus {
  Inactive = "Inactive",
  Active = "Active",
  Suspended = "Suspended",
  Deleted = "Deleted",
}


export enum AccountSize {
  Small = "Small",
  Medium = "Medium",
  Large = "Large",
}


export type ModelAccountConditionInput = {
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  name?: ModelStringInput | null,
  address?: ModelStringInput | null,
  city?: ModelStringInput | null,
  state?: ModelStringInput | null,
  postalCode?: ModelStringInput | null,
  accountType?: ModelAccountTypeInput | null,
  accountStatus?: ModelAccountStatusInput | null,
  accountSize?: ModelAccountSizeInput | null,
  customerId?: ModelStringInput | null,
  and?: Array< ModelAccountConditionInput | null > | null,
  or?: Array< ModelAccountConditionInput | null > | null,
  not?: ModelAccountConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelAccountTypeInput = {
  eq?: AccountType | null,
  ne?: AccountType | null,
};

export type ModelAccountStatusInput = {
  eq?: AccountStatus | null,
  ne?: AccountStatus | null,
};

export type ModelAccountSizeInput = {
  eq?: AccountSize | null,
  ne?: AccountSize | null,
};

export type Account = {
  __typename: "Account",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  ownerId?: string | null,
  name: string,
  address?: string | null,
  city?: string | null,
  state?: string | null,
  postalCode?: string | null,
  accountType?: AccountType | null,
  accountStatus?: AccountStatus | null,
  accountSize?: AccountSize | null,
  customerId?: string | null,
  users?: ModelUserConnection | null,
  classes?: ModelClassConnection | null,
  activity?: ModelActivityConnection | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type User = {
  __typename: "User",
  createdAt?: string | null,
  updatedAt?: string | null,
  account?: Account | null,
  firstName: string,
  lastName: string,
  phone?: string | null,
  jobTitle?: string | null,
  invitedAt?: string | null,
  registrations?: ModelRegistrationConnection | null,
  customerId?: string | null,
  id: string,
  accountId?: string | null,
  email: string,
  userStatus?: UserStatus | null,
  role?: UserRole | null,
};

export type ModelRegistrationConnection = {
  __typename: "ModelRegistrationConnection",
  items:  Array<Registration | null >,
  nextToken?: string | null,
};

export type Registration = {
  __typename: "Registration",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  accountId: string,
  classId: string,
  class?: Class | null,
  userId: string,
  user?: User | null,
  classStatus: ClassStatus,
  classProgress: number,
  lessonNumber: number,
  lessonId?: string | null,
  lessonStatus?: LessonStatus | null,
  videoProgress?: number | null,
  answers?: Array< number | null > | null,
  score: number,
  startedAt?: string | null,
  endsAt?: string | null,
  completedAt?: string | null,
  lessonsAssigned?: number | null,
  nextAssignmentAt?: string | null,
};

export type Class = {
  __typename: "Class",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  courseId: string,
  course?: Course | null,
  accountId: string,
  account?: Account | null,
  ownerId?: string | null,
  userId?: string | null,
  termBegin?: string | null,
  termEnd?: string | null,
  seatsPurchased?: number | null,
  seatsFilled?: number | null,
  couponCode?: string | null,
  assignmentSchedule?: AssignmentSchedule | null,
  registrations?: ModelRegistrationConnection | null,
};

export type Course = {
  __typename: "Course",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  title: string,
  description?: string | null,
  coverUrl?: string | null,
  details?: string | null,
  publishDate?: string | null,
  sunsetDate?: string | null,
  lessonCount?: number | null,
  creditHours?: number | null,
  isFree?: boolean | null,
  lessons?: string | null,
  classes?: ModelClassConnection | null,
};

export type ModelClassConnection = {
  __typename: "ModelClassConnection",
  items:  Array<Class | null >,
  nextToken?: string | null,
};

export enum AssignmentSchedule {
  All = "All",
  Monthly = "Monthly",
  Quarterly = "Quarterly",
}


export enum ClassStatus {
  NotStarted = "NotStarted",
  InProgress = "InProgress",
  Passed = "Passed",
  Failed = "Failed",
}


export enum LessonStatus {
  NotStarted = "NotStarted",
  InProgress = "InProgress",
  Ended = "Ended",
  Quiz = "Quiz",
  Passed = "Passed",
  Failed = "Failed",
}


export enum UserStatus {
  Inactive = "Inactive",
  Invited = "Invited",
  Registered = "Registered",
  Suspended = "Suspended",
  Deleted = "Deleted",
}


export enum UserRole {
  Student = "Student",
  Owner = "Owner",
  Admin = "Admin",
}


export type ModelActivityConnection = {
  __typename: "ModelActivityConnection",
  items:  Array<Activity | null >,
  nextToken?: string | null,
};

export type Activity = {
  __typename: "Activity",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  accountId: string,
  account: Account,
  userId: string,
  activityDate: string,
  activityType: ActivityType,
  objectId: string,
  values?: string | null,
};

export enum ActivityType {
  AccountCreate = "AccountCreate",
  ClassComplete = "ClassComplete",
  ClassCreate = "ClassCreate",
  ClassEdit = "ClassEdit",
  ClassPayment = "ClassPayment",
  ClassRegistration = "ClassRegistration",
  CourseCreate = "CourseCreate",
  CourseEdit = "CourseEdit",
  LessonComplete = "LessonComplete",
  UserCreate = "UserCreate",
  UserRegister = "UserRegister",
  UserSignIn = "UserSignIn",
}


export type UpdateAccountInput = {
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  ownerId?: string | null,
  name?: string | null,
  address?: string | null,
  city?: string | null,
  state?: string | null,
  postalCode?: string | null,
  accountType?: AccountType | null,
  accountStatus?: AccountStatus | null,
  accountSize?: AccountSize | null,
  customerId?: string | null,
};

export type DeleteAccountInput = {
  id: string,
};

export type CreateUserInput = {
  id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  accountId?: string | null,
  firstName: string,
  lastName: string,
  email: string,
  phone?: string | null,
  jobTitle?: string | null,
  userStatus?: UserStatus | null,
  invitedAt?: string | null,
  role?: UserRole | null,
  customerId?: string | null,
};

export type ModelUserConditionInput = {
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  jobTitle?: ModelStringInput | null,
  userStatus?: ModelUserStatusInput | null,
  invitedAt?: ModelStringInput | null,
  role?: ModelUserRoleInput | null,
  customerId?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
};

export type ModelUserStatusInput = {
  eq?: UserStatus | null,
  ne?: UserStatus | null,
};

export type ModelUserRoleInput = {
  eq?: UserRole | null,
  ne?: UserRole | null,
};

export type UpdateUserInput = {
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  accountId?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  jobTitle?: string | null,
  userStatus?: UserStatus | null,
  invitedAt?: string | null,
  role?: UserRole | null,
  customerId?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateCourseInput = {
  id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  title: string,
  description?: string | null,
  coverUrl?: string | null,
  details?: string | null,
  publishDate?: string | null,
  sunsetDate?: string | null,
  lessonCount?: number | null,
  creditHours?: number | null,
  isFree?: boolean | null,
  lessons?: string | null,
};

export type ModelCourseConditionInput = {
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  coverUrl?: ModelStringInput | null,
  details?: ModelStringInput | null,
  publishDate?: ModelStringInput | null,
  sunsetDate?: ModelStringInput | null,
  lessonCount?: ModelIntInput | null,
  creditHours?: ModelFloatInput | null,
  isFree?: ModelBooleanInput | null,
  lessons?: ModelStringInput | null,
  and?: Array< ModelCourseConditionInput | null > | null,
  or?: Array< ModelCourseConditionInput | null > | null,
  not?: ModelCourseConditionInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type UpdateCourseInput = {
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  title?: string | null,
  description?: string | null,
  coverUrl?: string | null,
  details?: string | null,
  publishDate?: string | null,
  sunsetDate?: string | null,
  lessonCount?: number | null,
  creditHours?: number | null,
  isFree?: boolean | null,
  lessons?: string | null,
};

export type DeleteCourseInput = {
  id: string,
};

export type CreateLessonInput = {
  id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  courseId: string,
  number: number,
  title: string,
  description?: string | null,
  videoUrl?: string | null,
  videoDuration?: number | null,
  standards?: string | null,
};

export type ModelLessonConditionInput = {
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  courseId?: ModelIDInput | null,
  number?: ModelIntInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  videoUrl?: ModelStringInput | null,
  videoDuration?: ModelIntInput | null,
  standards?: ModelStringInput | null,
  and?: Array< ModelLessonConditionInput | null > | null,
  or?: Array< ModelLessonConditionInput | null > | null,
  not?: ModelLessonConditionInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type Lesson = {
  __typename: "Lesson",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  courseId: string,
  number: number,
  title: string,
  description?: string | null,
  videoUrl?: string | null,
  videoDuration?: number | null,
  standards?: string | null,
  questions?: ModelQuestionConnection | null,
};

export type ModelQuestionConnection = {
  __typename: "ModelQuestionConnection",
  items:  Array<Question | null >,
  nextToken?: string | null,
};

export type Question = {
  __typename: "Question",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  lessonId: string,
  lesson?: Lesson | null,
  number?: number | null,
  question: string,
  answers?: Array< string | null > | null,
  correctAnswer?: number | null,
};

export type UpdateLessonInput = {
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  courseId?: string | null,
  number?: number | null,
  title?: string | null,
  description?: string | null,
  videoUrl?: string | null,
  videoDuration?: number | null,
  standards?: string | null,
};

export type DeleteLessonInput = {
  id: string,
};

export type CreateQuestionInput = {
  id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  lessonId: string,
  number?: number | null,
  question: string,
  answers?: Array< string | null > | null,
  correctAnswer?: number | null,
};

export type ModelQuestionConditionInput = {
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  lessonId?: ModelIDInput | null,
  number?: ModelIntInput | null,
  question?: ModelStringInput | null,
  answers?: ModelStringInput | null,
  correctAnswer?: ModelIntInput | null,
  and?: Array< ModelQuestionConditionInput | null > | null,
  or?: Array< ModelQuestionConditionInput | null > | null,
  not?: ModelQuestionConditionInput | null,
};

export type UpdateQuestionInput = {
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  lessonId?: string | null,
  number?: number | null,
  question?: string | null,
  answers?: Array< string | null > | null,
  correctAnswer?: number | null,
};

export type DeleteQuestionInput = {
  id: string,
};

export type CreateClassInput = {
  id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  courseId: string,
  accountId: string,
  ownerId?: string | null,
  userId?: string | null,
  termBegin?: string | null,
  termEnd?: string | null,
  seatsPurchased?: number | null,
  seatsFilled?: number | null,
  couponCode?: string | null,
  assignmentSchedule?: AssignmentSchedule | null,
};

export type ModelClassConditionInput = {
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  courseId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  termBegin?: ModelStringInput | null,
  termEnd?: ModelStringInput | null,
  seatsPurchased?: ModelIntInput | null,
  seatsFilled?: ModelIntInput | null,
  couponCode?: ModelStringInput | null,
  assignmentSchedule?: ModelAssignmentScheduleInput | null,
  and?: Array< ModelClassConditionInput | null > | null,
  or?: Array< ModelClassConditionInput | null > | null,
  not?: ModelClassConditionInput | null,
};

export type ModelAssignmentScheduleInput = {
  eq?: AssignmentSchedule | null,
  ne?: AssignmentSchedule | null,
};

export type UpdateClassInput = {
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  courseId?: string | null,
  accountId?: string | null,
  ownerId?: string | null,
  userId?: string | null,
  termBegin?: string | null,
  termEnd?: string | null,
  seatsPurchased?: number | null,
  seatsFilled?: number | null,
  couponCode?: string | null,
  assignmentSchedule?: AssignmentSchedule | null,
};

export type DeleteClassInput = {
  id: string,
};

export type CreateRegistrationInput = {
  id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  accountId: string,
  classId: string,
  userId: string,
  classStatus: ClassStatus,
  classProgress: number,
  lessonNumber: number,
  lessonId?: string | null,
  lessonStatus?: LessonStatus | null,
  videoProgress?: number | null,
  answers?: Array< number | null > | null,
  score: number,
  startedAt?: string | null,
  endsAt?: string | null,
  completedAt?: string | null,
  lessonsAssigned?: number | null,
  nextAssignmentAt?: string | null,
};

export type ModelRegistrationConditionInput = {
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  classId?: ModelIDInput | null,
  classStatus?: ModelClassStatusInput | null,
  classProgress?: ModelFloatInput | null,
  lessonNumber?: ModelIntInput | null,
  lessonId?: ModelIDInput | null,
  lessonStatus?: ModelLessonStatusInput | null,
  videoProgress?: ModelFloatInput | null,
  answers?: ModelIntInput | null,
  score?: ModelFloatInput | null,
  startedAt?: ModelStringInput | null,
  endsAt?: ModelStringInput | null,
  completedAt?: ModelStringInput | null,
  lessonsAssigned?: ModelIntInput | null,
  nextAssignmentAt?: ModelStringInput | null,
  and?: Array< ModelRegistrationConditionInput | null > | null,
  or?: Array< ModelRegistrationConditionInput | null > | null,
  not?: ModelRegistrationConditionInput | null,
};

export type ModelClassStatusInput = {
  eq?: ClassStatus | null,
  ne?: ClassStatus | null,
};

export type ModelLessonStatusInput = {
  eq?: LessonStatus | null,
  ne?: LessonStatus | null,
};

export type UpdateRegistrationInput = {
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  accountId?: string | null,
  classId?: string | null,
  userId?: string | null,
  classStatus?: ClassStatus | null,
  classProgress?: number | null,
  lessonNumber?: number | null,
  lessonId?: string | null,
  lessonStatus?: LessonStatus | null,
  videoProgress?: number | null,
  answers?: Array< number | null > | null,
  score?: number | null,
  startedAt?: string | null,
  endsAt?: string | null,
  completedAt?: string | null,
  lessonsAssigned?: number | null,
  nextAssignmentAt?: string | null,
};

export type DeleteRegistrationInput = {
  id: string,
};

export type CreateActivityInput = {
  id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  accountId: string,
  userId: string,
  activityDate: string,
  activityType: ActivityType,
  objectId: string,
  values?: string | null,
};

export type ModelActivityConditionInput = {
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  activityDate?: ModelStringInput | null,
  activityType?: ModelActivityTypeInput | null,
  objectId?: ModelIDInput | null,
  values?: ModelStringInput | null,
  and?: Array< ModelActivityConditionInput | null > | null,
  or?: Array< ModelActivityConditionInput | null > | null,
  not?: ModelActivityConditionInput | null,
};

export type ModelActivityTypeInput = {
  eq?: ActivityType | null,
  ne?: ActivityType | null,
};

export type UpdateActivityInput = {
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  accountId?: string | null,
  userId?: string | null,
  activityDate?: string | null,
  activityType?: ActivityType | null,
  objectId?: string | null,
  values?: string | null,
};

export type DeleteActivityInput = {
  id: string,
};

export type ModelAccountFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  ownerId?: ModelStringInput | null,
  name?: ModelStringInput | null,
  address?: ModelStringInput | null,
  city?: ModelStringInput | null,
  state?: ModelStringInput | null,
  postalCode?: ModelStringInput | null,
  accountType?: ModelAccountTypeInput | null,
  accountStatus?: ModelAccountStatusInput | null,
  accountSize?: ModelAccountSizeInput | null,
  customerId?: ModelStringInput | null,
  and?: Array< ModelAccountFilterInput | null > | null,
  or?: Array< ModelAccountFilterInput | null > | null,
  not?: ModelAccountFilterInput | null,
};

export type ModelAccountConnection = {
  __typename: "ModelAccountConnection",
  items:  Array<Account | null >,
  nextToken?: string | null,
};

export type ModelCourseFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  coverUrl?: ModelStringInput | null,
  details?: ModelStringInput | null,
  publishDate?: ModelStringInput | null,
  sunsetDate?: ModelStringInput | null,
  lessonCount?: ModelIntInput | null,
  creditHours?: ModelFloatInput | null,
  isFree?: ModelBooleanInput | null,
  lessons?: ModelStringInput | null,
  and?: Array< ModelCourseFilterInput | null > | null,
  or?: Array< ModelCourseFilterInput | null > | null,
  not?: ModelCourseFilterInput | null,
};

export type ModelCourseConnection = {
  __typename: "ModelCourseConnection",
  items:  Array<Course | null >,
  nextToken?: string | null,
};

export type ModelLessonFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  courseId?: ModelIDInput | null,
  number?: ModelIntInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  videoUrl?: ModelStringInput | null,
  videoDuration?: ModelIntInput | null,
  standards?: ModelStringInput | null,
  and?: Array< ModelLessonFilterInput | null > | null,
  or?: Array< ModelLessonFilterInput | null > | null,
  not?: ModelLessonFilterInput | null,
};

export type ModelLessonConnection = {
  __typename: "ModelLessonConnection",
  items:  Array<Lesson | null >,
  nextToken?: string | null,
};

export type ModelQuestionFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  lessonId?: ModelIDInput | null,
  number?: ModelIntInput | null,
  question?: ModelStringInput | null,
  answers?: ModelStringInput | null,
  correctAnswer?: ModelIntInput | null,
  and?: Array< ModelQuestionFilterInput | null > | null,
  or?: Array< ModelQuestionFilterInput | null > | null,
  not?: ModelQuestionFilterInput | null,
};

export type ModelClassFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  courseId?: ModelIDInput | null,
  accountId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  termBegin?: ModelStringInput | null,
  termEnd?: ModelStringInput | null,
  seatsPurchased?: ModelIntInput | null,
  seatsFilled?: ModelIntInput | null,
  couponCode?: ModelStringInput | null,
  assignmentSchedule?: ModelAssignmentScheduleInput | null,
  and?: Array< ModelClassFilterInput | null > | null,
  or?: Array< ModelClassFilterInput | null > | null,
  not?: ModelClassFilterInput | null,
};

export type ModelRegistrationFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  accountId?: ModelIDInput | null,
  classId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  classStatus?: ModelClassStatusInput | null,
  classProgress?: ModelFloatInput | null,
  lessonNumber?: ModelIntInput | null,
  lessonId?: ModelIDInput | null,
  lessonStatus?: ModelLessonStatusInput | null,
  videoProgress?: ModelFloatInput | null,
  answers?: ModelIntInput | null,
  score?: ModelFloatInput | null,
  startedAt?: ModelStringInput | null,
  endsAt?: ModelStringInput | null,
  completedAt?: ModelStringInput | null,
  lessonsAssigned?: ModelIntInput | null,
  nextAssignmentAt?: ModelStringInput | null,
  and?: Array< ModelRegistrationFilterInput | null > | null,
  or?: Array< ModelRegistrationFilterInput | null > | null,
  not?: ModelRegistrationFilterInput | null,
};

export type ModelActivityFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  accountId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  activityDate?: ModelStringInput | null,
  activityType?: ModelActivityTypeInput | null,
  objectId?: ModelIDInput | null,
  values?: ModelStringInput | null,
  and?: Array< ModelActivityFilterInput | null > | null,
  or?: Array< ModelActivityFilterInput | null > | null,
  not?: ModelActivityFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  accountId?: ModelIDInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  jobTitle?: ModelStringInput | null,
  userStatus?: ModelUserStatusInput | null,
  invitedAt?: ModelStringInput | null,
  role?: ModelUserRoleInput | null,
  customerId?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type CreateAccountMutationVariables = {
  input: CreateAccountInput,
  condition?: ModelAccountConditionInput | null,
};

export type CreateAccountMutation = {
  createAccount?:  {
    __typename: "Account",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    ownerId?: string | null,
    name: string,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    postalCode?: string | null,
    accountType?: AccountType | null,
    accountStatus?: AccountStatus | null,
    accountSize?: AccountSize | null,
    customerId?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        createdAt?: string | null,
        updatedAt?: string | null,
        firstName: string,
        lastName: string,
        phone?: string | null,
        jobTitle?: string | null,
        invitedAt?: string | null,
        customerId?: string | null,
        id: string,
        accountId?: string | null,
        email: string,
        userStatus?: UserStatus | null,
        role?: UserRole | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    activity?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        userId: string,
        activityDate: string,
        activityType: ActivityType,
        objectId: string,
        values?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateAccountMutationVariables = {
  input: UpdateAccountInput,
  condition?: ModelAccountConditionInput | null,
};

export type UpdateAccountMutation = {
  updateAccount?:  {
    __typename: "Account",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    ownerId?: string | null,
    name: string,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    postalCode?: string | null,
    accountType?: AccountType | null,
    accountStatus?: AccountStatus | null,
    accountSize?: AccountSize | null,
    customerId?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        createdAt?: string | null,
        updatedAt?: string | null,
        firstName: string,
        lastName: string,
        phone?: string | null,
        jobTitle?: string | null,
        invitedAt?: string | null,
        customerId?: string | null,
        id: string,
        accountId?: string | null,
        email: string,
        userStatus?: UserStatus | null,
        role?: UserRole | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    activity?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        userId: string,
        activityDate: string,
        activityType: ActivityType,
        objectId: string,
        values?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteAccountMutationVariables = {
  input: DeleteAccountInput,
  condition?: ModelAccountConditionInput | null,
};

export type DeleteAccountMutation = {
  deleteAccount?:  {
    __typename: "Account",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    ownerId?: string | null,
    name: string,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    postalCode?: string | null,
    accountType?: AccountType | null,
    accountStatus?: AccountStatus | null,
    accountSize?: AccountSize | null,
    customerId?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        createdAt?: string | null,
        updatedAt?: string | null,
        firstName: string,
        lastName: string,
        phone?: string | null,
        jobTitle?: string | null,
        invitedAt?: string | null,
        customerId?: string | null,
        id: string,
        accountId?: string | null,
        email: string,
        userStatus?: UserStatus | null,
        role?: UserRole | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    activity?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        userId: string,
        activityDate: string,
        activityType: ActivityType,
        objectId: string,
        values?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    createdAt?: string | null,
    updatedAt?: string | null,
    account?:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    firstName: string,
    lastName: string,
    phone?: string | null,
    jobTitle?: string | null,
    invitedAt?: string | null,
    registrations?:  {
      __typename: "ModelRegistrationConnection",
      items:  Array< {
        __typename: "Registration",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        classId: string,
        userId: string,
        classStatus: ClassStatus,
        classProgress: number,
        lessonNumber: number,
        lessonId?: string | null,
        lessonStatus?: LessonStatus | null,
        videoProgress?: number | null,
        answers?: Array< number | null > | null,
        score: number,
        startedAt?: string | null,
        endsAt?: string | null,
        completedAt?: string | null,
        lessonsAssigned?: number | null,
        nextAssignmentAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    customerId?: string | null,
    id: string,
    accountId?: string | null,
    email: string,
    userStatus?: UserStatus | null,
    role?: UserRole | null,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    createdAt?: string | null,
    updatedAt?: string | null,
    account?:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    firstName: string,
    lastName: string,
    phone?: string | null,
    jobTitle?: string | null,
    invitedAt?: string | null,
    registrations?:  {
      __typename: "ModelRegistrationConnection",
      items:  Array< {
        __typename: "Registration",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        classId: string,
        userId: string,
        classStatus: ClassStatus,
        classProgress: number,
        lessonNumber: number,
        lessonId?: string | null,
        lessonStatus?: LessonStatus | null,
        videoProgress?: number | null,
        answers?: Array< number | null > | null,
        score: number,
        startedAt?: string | null,
        endsAt?: string | null,
        completedAt?: string | null,
        lessonsAssigned?: number | null,
        nextAssignmentAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    customerId?: string | null,
    id: string,
    accountId?: string | null,
    email: string,
    userStatus?: UserStatus | null,
    role?: UserRole | null,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    createdAt?: string | null,
    updatedAt?: string | null,
    account?:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    firstName: string,
    lastName: string,
    phone?: string | null,
    jobTitle?: string | null,
    invitedAt?: string | null,
    registrations?:  {
      __typename: "ModelRegistrationConnection",
      items:  Array< {
        __typename: "Registration",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        classId: string,
        userId: string,
        classStatus: ClassStatus,
        classProgress: number,
        lessonNumber: number,
        lessonId?: string | null,
        lessonStatus?: LessonStatus | null,
        videoProgress?: number | null,
        answers?: Array< number | null > | null,
        score: number,
        startedAt?: string | null,
        endsAt?: string | null,
        completedAt?: string | null,
        lessonsAssigned?: number | null,
        nextAssignmentAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    customerId?: string | null,
    id: string,
    accountId?: string | null,
    email: string,
    userStatus?: UserStatus | null,
    role?: UserRole | null,
  } | null,
};

export type CreateCourseMutationVariables = {
  input: CreateCourseInput,
  condition?: ModelCourseConditionInput | null,
};

export type CreateCourseMutation = {
  createCourse?:  {
    __typename: "Course",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    title: string,
    description?: string | null,
    coverUrl?: string | null,
    details?: string | null,
    publishDate?: string | null,
    sunsetDate?: string | null,
    lessonCount?: number | null,
    creditHours?: number | null,
    isFree?: boolean | null,
    lessons?: string | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateCourseMutationVariables = {
  input: UpdateCourseInput,
  condition?: ModelCourseConditionInput | null,
};

export type UpdateCourseMutation = {
  updateCourse?:  {
    __typename: "Course",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    title: string,
    description?: string | null,
    coverUrl?: string | null,
    details?: string | null,
    publishDate?: string | null,
    sunsetDate?: string | null,
    lessonCount?: number | null,
    creditHours?: number | null,
    isFree?: boolean | null,
    lessons?: string | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteCourseMutationVariables = {
  input: DeleteCourseInput,
  condition?: ModelCourseConditionInput | null,
};

export type DeleteCourseMutation = {
  deleteCourse?:  {
    __typename: "Course",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    title: string,
    description?: string | null,
    coverUrl?: string | null,
    details?: string | null,
    publishDate?: string | null,
    sunsetDate?: string | null,
    lessonCount?: number | null,
    creditHours?: number | null,
    isFree?: boolean | null,
    lessons?: string | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateLessonMutationVariables = {
  input: CreateLessonInput,
  condition?: ModelLessonConditionInput | null,
};

export type CreateLessonMutation = {
  createLesson?:  {
    __typename: "Lesson",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    number: number,
    title: string,
    description?: string | null,
    videoUrl?: string | null,
    videoDuration?: number | null,
    standards?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        lessonId: string,
        number?: number | null,
        question: string,
        answers?: Array< string | null > | null,
        correctAnswer?: number | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateLessonMutationVariables = {
  input: UpdateLessonInput,
  condition?: ModelLessonConditionInput | null,
};

export type UpdateLessonMutation = {
  updateLesson?:  {
    __typename: "Lesson",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    number: number,
    title: string,
    description?: string | null,
    videoUrl?: string | null,
    videoDuration?: number | null,
    standards?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        lessonId: string,
        number?: number | null,
        question: string,
        answers?: Array< string | null > | null,
        correctAnswer?: number | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteLessonMutationVariables = {
  input: DeleteLessonInput,
  condition?: ModelLessonConditionInput | null,
};

export type DeleteLessonMutation = {
  deleteLesson?:  {
    __typename: "Lesson",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    number: number,
    title: string,
    description?: string | null,
    videoUrl?: string | null,
    videoDuration?: number | null,
    standards?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        lessonId: string,
        number?: number | null,
        question: string,
        answers?: Array< string | null > | null,
        correctAnswer?: number | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateQuestionMutationVariables = {
  input: CreateQuestionInput,
  condition?: ModelQuestionConditionInput | null,
};

export type CreateQuestionMutation = {
  createQuestion?:  {
    __typename: "Question",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      number: number,
      title: string,
      description?: string | null,
      videoUrl?: string | null,
      videoDuration?: number | null,
      standards?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    number?: number | null,
    question: string,
    answers?: Array< string | null > | null,
    correctAnswer?: number | null,
  } | null,
};

export type UpdateQuestionMutationVariables = {
  input: UpdateQuestionInput,
  condition?: ModelQuestionConditionInput | null,
};

export type UpdateQuestionMutation = {
  updateQuestion?:  {
    __typename: "Question",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      number: number,
      title: string,
      description?: string | null,
      videoUrl?: string | null,
      videoDuration?: number | null,
      standards?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    number?: number | null,
    question: string,
    answers?: Array< string | null > | null,
    correctAnswer?: number | null,
  } | null,
};

export type DeleteQuestionMutationVariables = {
  input: DeleteQuestionInput,
  condition?: ModelQuestionConditionInput | null,
};

export type DeleteQuestionMutation = {
  deleteQuestion?:  {
    __typename: "Question",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      number: number,
      title: string,
      description?: string | null,
      videoUrl?: string | null,
      videoDuration?: number | null,
      standards?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    number?: number | null,
    question: string,
    answers?: Array< string | null > | null,
    correctAnswer?: number | null,
  } | null,
};

export type CreateClassMutationVariables = {
  input: CreateClassInput,
  condition?: ModelClassConditionInput | null,
};

export type CreateClassMutation = {
  createClass?:  {
    __typename: "Class",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    course?:  {
      __typename: "Course",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      title: string,
      description?: string | null,
      coverUrl?: string | null,
      details?: string | null,
      publishDate?: string | null,
      sunsetDate?: string | null,
      lessonCount?: number | null,
      creditHours?: number | null,
      isFree?: boolean | null,
      lessons?: string | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    accountId: string,
    account?:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    ownerId?: string | null,
    userId?: string | null,
    termBegin?: string | null,
    termEnd?: string | null,
    seatsPurchased?: number | null,
    seatsFilled?: number | null,
    couponCode?: string | null,
    assignmentSchedule?: AssignmentSchedule | null,
    registrations?:  {
      __typename: "ModelRegistrationConnection",
      items:  Array< {
        __typename: "Registration",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        classId: string,
        userId: string,
        classStatus: ClassStatus,
        classProgress: number,
        lessonNumber: number,
        lessonId?: string | null,
        lessonStatus?: LessonStatus | null,
        videoProgress?: number | null,
        answers?: Array< number | null > | null,
        score: number,
        startedAt?: string | null,
        endsAt?: string | null,
        completedAt?: string | null,
        lessonsAssigned?: number | null,
        nextAssignmentAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateClassMutationVariables = {
  input: UpdateClassInput,
  condition?: ModelClassConditionInput | null,
};

export type UpdateClassMutation = {
  updateClass?:  {
    __typename: "Class",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    course?:  {
      __typename: "Course",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      title: string,
      description?: string | null,
      coverUrl?: string | null,
      details?: string | null,
      publishDate?: string | null,
      sunsetDate?: string | null,
      lessonCount?: number | null,
      creditHours?: number | null,
      isFree?: boolean | null,
      lessons?: string | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    accountId: string,
    account?:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    ownerId?: string | null,
    userId?: string | null,
    termBegin?: string | null,
    termEnd?: string | null,
    seatsPurchased?: number | null,
    seatsFilled?: number | null,
    couponCode?: string | null,
    assignmentSchedule?: AssignmentSchedule | null,
    registrations?:  {
      __typename: "ModelRegistrationConnection",
      items:  Array< {
        __typename: "Registration",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        classId: string,
        userId: string,
        classStatus: ClassStatus,
        classProgress: number,
        lessonNumber: number,
        lessonId?: string | null,
        lessonStatus?: LessonStatus | null,
        videoProgress?: number | null,
        answers?: Array< number | null > | null,
        score: number,
        startedAt?: string | null,
        endsAt?: string | null,
        completedAt?: string | null,
        lessonsAssigned?: number | null,
        nextAssignmentAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteClassMutationVariables = {
  input: DeleteClassInput,
  condition?: ModelClassConditionInput | null,
};

export type DeleteClassMutation = {
  deleteClass?:  {
    __typename: "Class",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    course?:  {
      __typename: "Course",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      title: string,
      description?: string | null,
      coverUrl?: string | null,
      details?: string | null,
      publishDate?: string | null,
      sunsetDate?: string | null,
      lessonCount?: number | null,
      creditHours?: number | null,
      isFree?: boolean | null,
      lessons?: string | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    accountId: string,
    account?:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    ownerId?: string | null,
    userId?: string | null,
    termBegin?: string | null,
    termEnd?: string | null,
    seatsPurchased?: number | null,
    seatsFilled?: number | null,
    couponCode?: string | null,
    assignmentSchedule?: AssignmentSchedule | null,
    registrations?:  {
      __typename: "ModelRegistrationConnection",
      items:  Array< {
        __typename: "Registration",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        classId: string,
        userId: string,
        classStatus: ClassStatus,
        classProgress: number,
        lessonNumber: number,
        lessonId?: string | null,
        lessonStatus?: LessonStatus | null,
        videoProgress?: number | null,
        answers?: Array< number | null > | null,
        score: number,
        startedAt?: string | null,
        endsAt?: string | null,
        completedAt?: string | null,
        lessonsAssigned?: number | null,
        nextAssignmentAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateRegistrationMutationVariables = {
  input: CreateRegistrationInput,
  condition?: ModelRegistrationConditionInput | null,
};

export type CreateRegistrationMutation = {
  createRegistration?:  {
    __typename: "Registration",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    classId: string,
    class?:  {
      __typename: "Class",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      course?:  {
        __typename: "Course",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        title: string,
        description?: string | null,
        coverUrl?: string | null,
        details?: string | null,
        publishDate?: string | null,
        sunsetDate?: string | null,
        lessonCount?: number | null,
        creditHours?: number | null,
        isFree?: boolean | null,
        lessons?: string | null,
      } | null,
      accountId: string,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      ownerId?: string | null,
      userId?: string | null,
      termBegin?: string | null,
      termEnd?: string | null,
      seatsPurchased?: number | null,
      seatsFilled?: number | null,
      couponCode?: string | null,
      assignmentSchedule?: AssignmentSchedule | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      createdAt?: string | null,
      updatedAt?: string | null,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      firstName: string,
      lastName: string,
      phone?: string | null,
      jobTitle?: string | null,
      invitedAt?: string | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
      customerId?: string | null,
      id: string,
      accountId?: string | null,
      email: string,
      userStatus?: UserStatus | null,
      role?: UserRole | null,
    } | null,
    classStatus: ClassStatus,
    classProgress: number,
    lessonNumber: number,
    lessonId?: string | null,
    lessonStatus?: LessonStatus | null,
    videoProgress?: number | null,
    answers?: Array< number | null > | null,
    score: number,
    startedAt?: string | null,
    endsAt?: string | null,
    completedAt?: string | null,
    lessonsAssigned?: number | null,
    nextAssignmentAt?: string | null,
  } | null,
};

export type UpdateRegistrationMutationVariables = {
  input: UpdateRegistrationInput,
  condition?: ModelRegistrationConditionInput | null,
};

export type UpdateRegistrationMutation = {
  updateRegistration?:  {
    __typename: "Registration",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    classId: string,
    class?:  {
      __typename: "Class",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      course?:  {
        __typename: "Course",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        title: string,
        description?: string | null,
        coverUrl?: string | null,
        details?: string | null,
        publishDate?: string | null,
        sunsetDate?: string | null,
        lessonCount?: number | null,
        creditHours?: number | null,
        isFree?: boolean | null,
        lessons?: string | null,
      } | null,
      accountId: string,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      ownerId?: string | null,
      userId?: string | null,
      termBegin?: string | null,
      termEnd?: string | null,
      seatsPurchased?: number | null,
      seatsFilled?: number | null,
      couponCode?: string | null,
      assignmentSchedule?: AssignmentSchedule | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      createdAt?: string | null,
      updatedAt?: string | null,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      firstName: string,
      lastName: string,
      phone?: string | null,
      jobTitle?: string | null,
      invitedAt?: string | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
      customerId?: string | null,
      id: string,
      accountId?: string | null,
      email: string,
      userStatus?: UserStatus | null,
      role?: UserRole | null,
    } | null,
    classStatus: ClassStatus,
    classProgress: number,
    lessonNumber: number,
    lessonId?: string | null,
    lessonStatus?: LessonStatus | null,
    videoProgress?: number | null,
    answers?: Array< number | null > | null,
    score: number,
    startedAt?: string | null,
    endsAt?: string | null,
    completedAt?: string | null,
    lessonsAssigned?: number | null,
    nextAssignmentAt?: string | null,
  } | null,
};

export type DeleteRegistrationMutationVariables = {
  input: DeleteRegistrationInput,
  condition?: ModelRegistrationConditionInput | null,
};

export type DeleteRegistrationMutation = {
  deleteRegistration?:  {
    __typename: "Registration",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    classId: string,
    class?:  {
      __typename: "Class",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      course?:  {
        __typename: "Course",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        title: string,
        description?: string | null,
        coverUrl?: string | null,
        details?: string | null,
        publishDate?: string | null,
        sunsetDate?: string | null,
        lessonCount?: number | null,
        creditHours?: number | null,
        isFree?: boolean | null,
        lessons?: string | null,
      } | null,
      accountId: string,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      ownerId?: string | null,
      userId?: string | null,
      termBegin?: string | null,
      termEnd?: string | null,
      seatsPurchased?: number | null,
      seatsFilled?: number | null,
      couponCode?: string | null,
      assignmentSchedule?: AssignmentSchedule | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      createdAt?: string | null,
      updatedAt?: string | null,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      firstName: string,
      lastName: string,
      phone?: string | null,
      jobTitle?: string | null,
      invitedAt?: string | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
      customerId?: string | null,
      id: string,
      accountId?: string | null,
      email: string,
      userStatus?: UserStatus | null,
      role?: UserRole | null,
    } | null,
    classStatus: ClassStatus,
    classProgress: number,
    lessonNumber: number,
    lessonId?: string | null,
    lessonStatus?: LessonStatus | null,
    videoProgress?: number | null,
    answers?: Array< number | null > | null,
    score: number,
    startedAt?: string | null,
    endsAt?: string | null,
    completedAt?: string | null,
    lessonsAssigned?: number | null,
    nextAssignmentAt?: string | null,
  } | null,
};

export type CreateActivityMutationVariables = {
  input: CreateActivityInput,
  condition?: ModelActivityConditionInput | null,
};

export type CreateActivityMutation = {
  createActivity?:  {
    __typename: "Activity",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    },
    userId: string,
    activityDate: string,
    activityType: ActivityType,
    objectId: string,
    values?: string | null,
  } | null,
};

export type UpdateActivityMutationVariables = {
  input: UpdateActivityInput,
  condition?: ModelActivityConditionInput | null,
};

export type UpdateActivityMutation = {
  updateActivity?:  {
    __typename: "Activity",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    },
    userId: string,
    activityDate: string,
    activityType: ActivityType,
    objectId: string,
    values?: string | null,
  } | null,
};

export type DeleteActivityMutationVariables = {
  input: DeleteActivityInput,
  condition?: ModelActivityConditionInput | null,
};

export type DeleteActivityMutation = {
  deleteActivity?:  {
    __typename: "Activity",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    },
    userId: string,
    activityDate: string,
    activityType: ActivityType,
    objectId: string,
    values?: string | null,
  } | null,
};

export type GetAccountQueryVariables = {
  id: string,
};

export type GetAccountQuery = {
  getAccount?:  {
    __typename: "Account",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    ownerId?: string | null,
    name: string,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    postalCode?: string | null,
    accountType?: AccountType | null,
    accountStatus?: AccountStatus | null,
    accountSize?: AccountSize | null,
    customerId?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        createdAt?: string | null,
        updatedAt?: string | null,
        firstName: string,
        lastName: string,
        phone?: string | null,
        jobTitle?: string | null,
        invitedAt?: string | null,
        customerId?: string | null,
        id: string,
        accountId?: string | null,
        email: string,
        userStatus?: UserStatus | null,
        role?: UserRole | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    activity?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        userId: string,
        activityDate: string,
        activityType: ActivityType,
        objectId: string,
        values?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListAccountsQueryVariables = {
  filter?: ModelAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAccountsQuery = {
  listAccounts?:  {
    __typename: "ModelAccountConnection",
    items:  Array< {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCourseQueryVariables = {
  id: string,
};

export type GetCourseQuery = {
  getCourse?:  {
    __typename: "Course",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    title: string,
    description?: string | null,
    coverUrl?: string | null,
    details?: string | null,
    publishDate?: string | null,
    sunsetDate?: string | null,
    lessonCount?: number | null,
    creditHours?: number | null,
    isFree?: boolean | null,
    lessons?: string | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListCoursesQueryVariables = {
  filter?: ModelCourseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCoursesQuery = {
  listCourses?:  {
    __typename: "ModelCourseConnection",
    items:  Array< {
      __typename: "Course",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      title: string,
      description?: string | null,
      coverUrl?: string | null,
      details?: string | null,
      publishDate?: string | null,
      sunsetDate?: string | null,
      lessonCount?: number | null,
      creditHours?: number | null,
      isFree?: boolean | null,
      lessons?: string | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLessonQueryVariables = {
  id: string,
};

export type GetLessonQuery = {
  getLesson?:  {
    __typename: "Lesson",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    number: number,
    title: string,
    description?: string | null,
    videoUrl?: string | null,
    videoDuration?: number | null,
    standards?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        lessonId: string,
        number?: number | null,
        question: string,
        answers?: Array< string | null > | null,
        correctAnswer?: number | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListLessonsQueryVariables = {
  filter?: ModelLessonFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLessonsQuery = {
  listLessons?:  {
    __typename: "ModelLessonConnection",
    items:  Array< {
      __typename: "Lesson",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      number: number,
      title: string,
      description?: string | null,
      videoUrl?: string | null,
      videoDuration?: number | null,
      standards?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetQuestionQueryVariables = {
  id: string,
};

export type GetQuestionQuery = {
  getQuestion?:  {
    __typename: "Question",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      number: number,
      title: string,
      description?: string | null,
      videoUrl?: string | null,
      videoDuration?: number | null,
      standards?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    number?: number | null,
    question: string,
    answers?: Array< string | null > | null,
    correctAnswer?: number | null,
  } | null,
};

export type ListQuestionsQueryVariables = {
  filter?: ModelQuestionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListQuestionsQuery = {
  listQuestions?:  {
    __typename: "ModelQuestionConnection",
    items:  Array< {
      __typename: "Question",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      lessonId: string,
      lesson?:  {
        __typename: "Lesson",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        number: number,
        title: string,
        description?: string | null,
        videoUrl?: string | null,
        videoDuration?: number | null,
        standards?: string | null,
      } | null,
      number?: number | null,
      question: string,
      answers?: Array< string | null > | null,
      correctAnswer?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetClassQueryVariables = {
  id: string,
};

export type GetClassQuery = {
  getClass?:  {
    __typename: "Class",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    course?:  {
      __typename: "Course",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      title: string,
      description?: string | null,
      coverUrl?: string | null,
      details?: string | null,
      publishDate?: string | null,
      sunsetDate?: string | null,
      lessonCount?: number | null,
      creditHours?: number | null,
      isFree?: boolean | null,
      lessons?: string | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    accountId: string,
    account?:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    ownerId?: string | null,
    userId?: string | null,
    termBegin?: string | null,
    termEnd?: string | null,
    seatsPurchased?: number | null,
    seatsFilled?: number | null,
    couponCode?: string | null,
    assignmentSchedule?: AssignmentSchedule | null,
    registrations?:  {
      __typename: "ModelRegistrationConnection",
      items:  Array< {
        __typename: "Registration",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        classId: string,
        userId: string,
        classStatus: ClassStatus,
        classProgress: number,
        lessonNumber: number,
        lessonId?: string | null,
        lessonStatus?: LessonStatus | null,
        videoProgress?: number | null,
        answers?: Array< number | null > | null,
        score: number,
        startedAt?: string | null,
        endsAt?: string | null,
        completedAt?: string | null,
        lessonsAssigned?: number | null,
        nextAssignmentAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListClasssQueryVariables = {
  filter?: ModelClassFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListClasssQuery = {
  listClasss?:  {
    __typename: "ModelClassConnection",
    items:  Array< {
      __typename: "Class",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      course?:  {
        __typename: "Course",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        title: string,
        description?: string | null,
        coverUrl?: string | null,
        details?: string | null,
        publishDate?: string | null,
        sunsetDate?: string | null,
        lessonCount?: number | null,
        creditHours?: number | null,
        isFree?: boolean | null,
        lessons?: string | null,
      } | null,
      accountId: string,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      ownerId?: string | null,
      userId?: string | null,
      termBegin?: string | null,
      termEnd?: string | null,
      seatsPurchased?: number | null,
      seatsFilled?: number | null,
      couponCode?: string | null,
      assignmentSchedule?: AssignmentSchedule | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRegistrationQueryVariables = {
  id: string,
};

export type GetRegistrationQuery = {
  getRegistration?:  {
    __typename: "Registration",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    classId: string,
    class?:  {
      __typename: "Class",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      course?:  {
        __typename: "Course",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        title: string,
        description?: string | null,
        coverUrl?: string | null,
        details?: string | null,
        publishDate?: string | null,
        sunsetDate?: string | null,
        lessonCount?: number | null,
        creditHours?: number | null,
        isFree?: boolean | null,
        lessons?: string | null,
      } | null,
      accountId: string,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      ownerId?: string | null,
      userId?: string | null,
      termBegin?: string | null,
      termEnd?: string | null,
      seatsPurchased?: number | null,
      seatsFilled?: number | null,
      couponCode?: string | null,
      assignmentSchedule?: AssignmentSchedule | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      createdAt?: string | null,
      updatedAt?: string | null,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      firstName: string,
      lastName: string,
      phone?: string | null,
      jobTitle?: string | null,
      invitedAt?: string | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
      customerId?: string | null,
      id: string,
      accountId?: string | null,
      email: string,
      userStatus?: UserStatus | null,
      role?: UserRole | null,
    } | null,
    classStatus: ClassStatus,
    classProgress: number,
    lessonNumber: number,
    lessonId?: string | null,
    lessonStatus?: LessonStatus | null,
    videoProgress?: number | null,
    answers?: Array< number | null > | null,
    score: number,
    startedAt?: string | null,
    endsAt?: string | null,
    completedAt?: string | null,
    lessonsAssigned?: number | null,
    nextAssignmentAt?: string | null,
  } | null,
};

export type ListRegistrationsQueryVariables = {
  filter?: ModelRegistrationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRegistrationsQuery = {
  listRegistrations?:  {
    __typename: "ModelRegistrationConnection",
    items:  Array< {
      __typename: "Registration",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      accountId: string,
      classId: string,
      class?:  {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null,
      userId: string,
      user?:  {
        __typename: "User",
        createdAt?: string | null,
        updatedAt?: string | null,
        firstName: string,
        lastName: string,
        phone?: string | null,
        jobTitle?: string | null,
        invitedAt?: string | null,
        customerId?: string | null,
        id: string,
        accountId?: string | null,
        email: string,
        userStatus?: UserStatus | null,
        role?: UserRole | null,
      } | null,
      classStatus: ClassStatus,
      classProgress: number,
      lessonNumber: number,
      lessonId?: string | null,
      lessonStatus?: LessonStatus | null,
      videoProgress?: number | null,
      answers?: Array< number | null > | null,
      score: number,
      startedAt?: string | null,
      endsAt?: string | null,
      completedAt?: string | null,
      lessonsAssigned?: number | null,
      nextAssignmentAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetActivityQueryVariables = {
  id: string,
};

export type GetActivityQuery = {
  getActivity?:  {
    __typename: "Activity",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    },
    userId: string,
    activityDate: string,
    activityType: ActivityType,
    objectId: string,
    values?: string | null,
  } | null,
};

export type ListActivitysQueryVariables = {
  filter?: ModelActivityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActivitysQuery = {
  listActivitys?:  {
    __typename: "ModelActivityConnection",
    items:  Array< {
      __typename: "Activity",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      accountId: string,
      account:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      },
      userId: string,
      activityDate: string,
      activityType: ActivityType,
      objectId: string,
      values?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListActivityByDateQueryVariables = {
  activityDate?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActivityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActivityByDateQuery = {
  listActivityByDate?:  {
    __typename: "ModelActivityConnection",
    items:  Array< {
      __typename: "Activity",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      accountId: string,
      account:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      },
      userId: string,
      activityDate: string,
      activityType: ActivityType,
      objectId: string,
      values?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListActivityByAccountQueryVariables = {
  accountId?: string | null,
  activityDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActivityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActivityByAccountQuery = {
  listActivityByAccount?:  {
    __typename: "ModelActivityConnection",
    items:  Array< {
      __typename: "Activity",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      accountId: string,
      account:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      },
      userId: string,
      activityDate: string,
      activityType: ActivityType,
      objectId: string,
      values?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    createdAt?: string | null,
    updatedAt?: string | null,
    account?:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    firstName: string,
    lastName: string,
    phone?: string | null,
    jobTitle?: string | null,
    invitedAt?: string | null,
    registrations?:  {
      __typename: "ModelRegistrationConnection",
      items:  Array< {
        __typename: "Registration",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        classId: string,
        userId: string,
        classStatus: ClassStatus,
        classProgress: number,
        lessonNumber: number,
        lessonId?: string | null,
        lessonStatus?: LessonStatus | null,
        videoProgress?: number | null,
        answers?: Array< number | null > | null,
        score: number,
        startedAt?: string | null,
        endsAt?: string | null,
        completedAt?: string | null,
        lessonsAssigned?: number | null,
        nextAssignmentAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    customerId?: string | null,
    id: string,
    accountId?: string | null,
    email: string,
    userStatus?: UserStatus | null,
    role?: UserRole | null,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      createdAt?: string | null,
      updatedAt?: string | null,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      firstName: string,
      lastName: string,
      phone?: string | null,
      jobTitle?: string | null,
      invitedAt?: string | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
      customerId?: string | null,
      id: string,
      accountId?: string | null,
      email: string,
      userStatus?: UserStatus | null,
      role?: UserRole | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreateAccountSubscriptionVariables = {
  ownerId?: string | null,
};

export type OnCreateAccountSubscription = {
  onCreateAccount?:  {
    __typename: "Account",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    ownerId?: string | null,
    name: string,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    postalCode?: string | null,
    accountType?: AccountType | null,
    accountStatus?: AccountStatus | null,
    accountSize?: AccountSize | null,
    customerId?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        createdAt?: string | null,
        updatedAt?: string | null,
        firstName: string,
        lastName: string,
        phone?: string | null,
        jobTitle?: string | null,
        invitedAt?: string | null,
        customerId?: string | null,
        id: string,
        accountId?: string | null,
        email: string,
        userStatus?: UserStatus | null,
        role?: UserRole | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    activity?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        userId: string,
        activityDate: string,
        activityType: ActivityType,
        objectId: string,
        values?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateAccountSubscriptionVariables = {
  ownerId?: string | null,
};

export type OnUpdateAccountSubscription = {
  onUpdateAccount?:  {
    __typename: "Account",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    ownerId?: string | null,
    name: string,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    postalCode?: string | null,
    accountType?: AccountType | null,
    accountStatus?: AccountStatus | null,
    accountSize?: AccountSize | null,
    customerId?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        createdAt?: string | null,
        updatedAt?: string | null,
        firstName: string,
        lastName: string,
        phone?: string | null,
        jobTitle?: string | null,
        invitedAt?: string | null,
        customerId?: string | null,
        id: string,
        accountId?: string | null,
        email: string,
        userStatus?: UserStatus | null,
        role?: UserRole | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    activity?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        userId: string,
        activityDate: string,
        activityType: ActivityType,
        objectId: string,
        values?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteAccountSubscriptionVariables = {
  ownerId?: string | null,
};

export type OnDeleteAccountSubscription = {
  onDeleteAccount?:  {
    __typename: "Account",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    ownerId?: string | null,
    name: string,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    postalCode?: string | null,
    accountType?: AccountType | null,
    accountStatus?: AccountStatus | null,
    accountSize?: AccountSize | null,
    customerId?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        createdAt?: string | null,
        updatedAt?: string | null,
        firstName: string,
        lastName: string,
        phone?: string | null,
        jobTitle?: string | null,
        invitedAt?: string | null,
        customerId?: string | null,
        id: string,
        accountId?: string | null,
        email: string,
        userStatus?: UserStatus | null,
        role?: UserRole | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    activity?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        userId: string,
        activityDate: string,
        activityType: ActivityType,
        objectId: string,
        values?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateCourseSubscription = {
  onCreateCourse?:  {
    __typename: "Course",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    title: string,
    description?: string | null,
    coverUrl?: string | null,
    details?: string | null,
    publishDate?: string | null,
    sunsetDate?: string | null,
    lessonCount?: number | null,
    creditHours?: number | null,
    isFree?: boolean | null,
    lessons?: string | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateCourseSubscription = {
  onUpdateCourse?:  {
    __typename: "Course",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    title: string,
    description?: string | null,
    coverUrl?: string | null,
    details?: string | null,
    publishDate?: string | null,
    sunsetDate?: string | null,
    lessonCount?: number | null,
    creditHours?: number | null,
    isFree?: boolean | null,
    lessons?: string | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteCourseSubscription = {
  onDeleteCourse?:  {
    __typename: "Course",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    title: string,
    description?: string | null,
    coverUrl?: string | null,
    details?: string | null,
    publishDate?: string | null,
    sunsetDate?: string | null,
    lessonCount?: number | null,
    creditHours?: number | null,
    isFree?: boolean | null,
    lessons?: string | null,
    classes?:  {
      __typename: "ModelClassConnection",
      items:  Array< {
        __typename: "Class",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        courseId: string,
        accountId: string,
        ownerId?: string | null,
        userId?: string | null,
        termBegin?: string | null,
        termEnd?: string | null,
        seatsPurchased?: number | null,
        seatsFilled?: number | null,
        couponCode?: string | null,
        assignmentSchedule?: AssignmentSchedule | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateLessonSubscription = {
  onCreateLesson?:  {
    __typename: "Lesson",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    number: number,
    title: string,
    description?: string | null,
    videoUrl?: string | null,
    videoDuration?: number | null,
    standards?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        lessonId: string,
        number?: number | null,
        question: string,
        answers?: Array< string | null > | null,
        correctAnswer?: number | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateLessonSubscription = {
  onUpdateLesson?:  {
    __typename: "Lesson",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    number: number,
    title: string,
    description?: string | null,
    videoUrl?: string | null,
    videoDuration?: number | null,
    standards?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        lessonId: string,
        number?: number | null,
        question: string,
        answers?: Array< string | null > | null,
        correctAnswer?: number | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteLessonSubscription = {
  onDeleteLesson?:  {
    __typename: "Lesson",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    number: number,
    title: string,
    description?: string | null,
    videoUrl?: string | null,
    videoDuration?: number | null,
    standards?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        lessonId: string,
        number?: number | null,
        question: string,
        answers?: Array< string | null > | null,
        correctAnswer?: number | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateQuestionSubscription = {
  onCreateQuestion?:  {
    __typename: "Question",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      number: number,
      title: string,
      description?: string | null,
      videoUrl?: string | null,
      videoDuration?: number | null,
      standards?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    number?: number | null,
    question: string,
    answers?: Array< string | null > | null,
    correctAnswer?: number | null,
  } | null,
};

export type OnUpdateQuestionSubscription = {
  onUpdateQuestion?:  {
    __typename: "Question",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      number: number,
      title: string,
      description?: string | null,
      videoUrl?: string | null,
      videoDuration?: number | null,
      standards?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    number?: number | null,
    question: string,
    answers?: Array< string | null > | null,
    correctAnswer?: number | null,
  } | null,
};

export type OnDeleteQuestionSubscription = {
  onDeleteQuestion?:  {
    __typename: "Question",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    lessonId: string,
    lesson?:  {
      __typename: "Lesson",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      number: number,
      title: string,
      description?: string | null,
      videoUrl?: string | null,
      videoDuration?: number | null,
      standards?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    number?: number | null,
    question: string,
    answers?: Array< string | null > | null,
    correctAnswer?: number | null,
  } | null,
};

export type OnCreateClassSubscriptionVariables = {
  ownerId?: string | null,
};

export type OnCreateClassSubscription = {
  onCreateClass?:  {
    __typename: "Class",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    course?:  {
      __typename: "Course",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      title: string,
      description?: string | null,
      coverUrl?: string | null,
      details?: string | null,
      publishDate?: string | null,
      sunsetDate?: string | null,
      lessonCount?: number | null,
      creditHours?: number | null,
      isFree?: boolean | null,
      lessons?: string | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    accountId: string,
    account?:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    ownerId?: string | null,
    userId?: string | null,
    termBegin?: string | null,
    termEnd?: string | null,
    seatsPurchased?: number | null,
    seatsFilled?: number | null,
    couponCode?: string | null,
    assignmentSchedule?: AssignmentSchedule | null,
    registrations?:  {
      __typename: "ModelRegistrationConnection",
      items:  Array< {
        __typename: "Registration",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        classId: string,
        userId: string,
        classStatus: ClassStatus,
        classProgress: number,
        lessonNumber: number,
        lessonId?: string | null,
        lessonStatus?: LessonStatus | null,
        videoProgress?: number | null,
        answers?: Array< number | null > | null,
        score: number,
        startedAt?: string | null,
        endsAt?: string | null,
        completedAt?: string | null,
        lessonsAssigned?: number | null,
        nextAssignmentAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateClassSubscriptionVariables = {
  ownerId?: string | null,
};

export type OnUpdateClassSubscription = {
  onUpdateClass?:  {
    __typename: "Class",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    course?:  {
      __typename: "Course",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      title: string,
      description?: string | null,
      coverUrl?: string | null,
      details?: string | null,
      publishDate?: string | null,
      sunsetDate?: string | null,
      lessonCount?: number | null,
      creditHours?: number | null,
      isFree?: boolean | null,
      lessons?: string | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    accountId: string,
    account?:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    ownerId?: string | null,
    userId?: string | null,
    termBegin?: string | null,
    termEnd?: string | null,
    seatsPurchased?: number | null,
    seatsFilled?: number | null,
    couponCode?: string | null,
    assignmentSchedule?: AssignmentSchedule | null,
    registrations?:  {
      __typename: "ModelRegistrationConnection",
      items:  Array< {
        __typename: "Registration",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        classId: string,
        userId: string,
        classStatus: ClassStatus,
        classProgress: number,
        lessonNumber: number,
        lessonId?: string | null,
        lessonStatus?: LessonStatus | null,
        videoProgress?: number | null,
        answers?: Array< number | null > | null,
        score: number,
        startedAt?: string | null,
        endsAt?: string | null,
        completedAt?: string | null,
        lessonsAssigned?: number | null,
        nextAssignmentAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteClassSubscriptionVariables = {
  ownerId?: string | null,
};

export type OnDeleteClassSubscription = {
  onDeleteClass?:  {
    __typename: "Class",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    courseId: string,
    course?:  {
      __typename: "Course",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      title: string,
      description?: string | null,
      coverUrl?: string | null,
      details?: string | null,
      publishDate?: string | null,
      sunsetDate?: string | null,
      lessonCount?: number | null,
      creditHours?: number | null,
      isFree?: boolean | null,
      lessons?: string | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    accountId: string,
    account?:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    ownerId?: string | null,
    userId?: string | null,
    termBegin?: string | null,
    termEnd?: string | null,
    seatsPurchased?: number | null,
    seatsFilled?: number | null,
    couponCode?: string | null,
    assignmentSchedule?: AssignmentSchedule | null,
    registrations?:  {
      __typename: "ModelRegistrationConnection",
      items:  Array< {
        __typename: "Registration",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        accountId: string,
        classId: string,
        userId: string,
        classStatus: ClassStatus,
        classProgress: number,
        lessonNumber: number,
        lessonId?: string | null,
        lessonStatus?: LessonStatus | null,
        videoProgress?: number | null,
        answers?: Array< number | null > | null,
        score: number,
        startedAt?: string | null,
        endsAt?: string | null,
        completedAt?: string | null,
        lessonsAssigned?: number | null,
        nextAssignmentAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateRegistrationSubscriptionVariables = {
  userId?: string | null,
};

export type OnCreateRegistrationSubscription = {
  onCreateRegistration?:  {
    __typename: "Registration",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    classId: string,
    class?:  {
      __typename: "Class",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      course?:  {
        __typename: "Course",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        title: string,
        description?: string | null,
        coverUrl?: string | null,
        details?: string | null,
        publishDate?: string | null,
        sunsetDate?: string | null,
        lessonCount?: number | null,
        creditHours?: number | null,
        isFree?: boolean | null,
        lessons?: string | null,
      } | null,
      accountId: string,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      ownerId?: string | null,
      userId?: string | null,
      termBegin?: string | null,
      termEnd?: string | null,
      seatsPurchased?: number | null,
      seatsFilled?: number | null,
      couponCode?: string | null,
      assignmentSchedule?: AssignmentSchedule | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      createdAt?: string | null,
      updatedAt?: string | null,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      firstName: string,
      lastName: string,
      phone?: string | null,
      jobTitle?: string | null,
      invitedAt?: string | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
      customerId?: string | null,
      id: string,
      accountId?: string | null,
      email: string,
      userStatus?: UserStatus | null,
      role?: UserRole | null,
    } | null,
    classStatus: ClassStatus,
    classProgress: number,
    lessonNumber: number,
    lessonId?: string | null,
    lessonStatus?: LessonStatus | null,
    videoProgress?: number | null,
    answers?: Array< number | null > | null,
    score: number,
    startedAt?: string | null,
    endsAt?: string | null,
    completedAt?: string | null,
    lessonsAssigned?: number | null,
    nextAssignmentAt?: string | null,
  } | null,
};

export type OnUpdateRegistrationSubscriptionVariables = {
  userId?: string | null,
};

export type OnUpdateRegistrationSubscription = {
  onUpdateRegistration?:  {
    __typename: "Registration",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    classId: string,
    class?:  {
      __typename: "Class",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      course?:  {
        __typename: "Course",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        title: string,
        description?: string | null,
        coverUrl?: string | null,
        details?: string | null,
        publishDate?: string | null,
        sunsetDate?: string | null,
        lessonCount?: number | null,
        creditHours?: number | null,
        isFree?: boolean | null,
        lessons?: string | null,
      } | null,
      accountId: string,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      ownerId?: string | null,
      userId?: string | null,
      termBegin?: string | null,
      termEnd?: string | null,
      seatsPurchased?: number | null,
      seatsFilled?: number | null,
      couponCode?: string | null,
      assignmentSchedule?: AssignmentSchedule | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      createdAt?: string | null,
      updatedAt?: string | null,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      firstName: string,
      lastName: string,
      phone?: string | null,
      jobTitle?: string | null,
      invitedAt?: string | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
      customerId?: string | null,
      id: string,
      accountId?: string | null,
      email: string,
      userStatus?: UserStatus | null,
      role?: UserRole | null,
    } | null,
    classStatus: ClassStatus,
    classProgress: number,
    lessonNumber: number,
    lessonId?: string | null,
    lessonStatus?: LessonStatus | null,
    videoProgress?: number | null,
    answers?: Array< number | null > | null,
    score: number,
    startedAt?: string | null,
    endsAt?: string | null,
    completedAt?: string | null,
    lessonsAssigned?: number | null,
    nextAssignmentAt?: string | null,
  } | null,
};

export type OnDeleteRegistrationSubscriptionVariables = {
  userId?: string | null,
};

export type OnDeleteRegistrationSubscription = {
  onDeleteRegistration?:  {
    __typename: "Registration",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    classId: string,
    class?:  {
      __typename: "Class",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      courseId: string,
      course?:  {
        __typename: "Course",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        title: string,
        description?: string | null,
        coverUrl?: string | null,
        details?: string | null,
        publishDate?: string | null,
        sunsetDate?: string | null,
        lessonCount?: number | null,
        creditHours?: number | null,
        isFree?: boolean | null,
        lessons?: string | null,
      } | null,
      accountId: string,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      ownerId?: string | null,
      userId?: string | null,
      termBegin?: string | null,
      termEnd?: string | null,
      seatsPurchased?: number | null,
      seatsFilled?: number | null,
      couponCode?: string | null,
      assignmentSchedule?: AssignmentSchedule | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    userId: string,
    user?:  {
      __typename: "User",
      createdAt?: string | null,
      updatedAt?: string | null,
      account?:  {
        __typename: "Account",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        ownerId?: string | null,
        name: string,
        address?: string | null,
        city?: string | null,
        state?: string | null,
        postalCode?: string | null,
        accountType?: AccountType | null,
        accountStatus?: AccountStatus | null,
        accountSize?: AccountSize | null,
        customerId?: string | null,
      } | null,
      firstName: string,
      lastName: string,
      phone?: string | null,
      jobTitle?: string | null,
      invitedAt?: string | null,
      registrations?:  {
        __typename: "ModelRegistrationConnection",
        nextToken?: string | null,
      } | null,
      customerId?: string | null,
      id: string,
      accountId?: string | null,
      email: string,
      userStatus?: UserStatus | null,
      role?: UserRole | null,
    } | null,
    classStatus: ClassStatus,
    classProgress: number,
    lessonNumber: number,
    lessonId?: string | null,
    lessonStatus?: LessonStatus | null,
    videoProgress?: number | null,
    answers?: Array< number | null > | null,
    score: number,
    startedAt?: string | null,
    endsAt?: string | null,
    completedAt?: string | null,
    lessonsAssigned?: number | null,
    nextAssignmentAt?: string | null,
  } | null,
};

export type OnCreateActivitySubscriptionVariables = {
  userId?: string | null,
};

export type OnCreateActivitySubscription = {
  onCreateActivity?:  {
    __typename: "Activity",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    },
    userId: string,
    activityDate: string,
    activityType: ActivityType,
    objectId: string,
    values?: string | null,
  } | null,
};

export type OnUpdateActivitySubscriptionVariables = {
  userId?: string | null,
};

export type OnUpdateActivitySubscription = {
  onUpdateActivity?:  {
    __typename: "Activity",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    },
    userId: string,
    activityDate: string,
    activityType: ActivityType,
    objectId: string,
    values?: string | null,
  } | null,
};

export type OnDeleteActivitySubscriptionVariables = {
  userId?: string | null,
};

export type OnDeleteActivitySubscription = {
  onDeleteActivity?:  {
    __typename: "Activity",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      ownerId?: string | null,
      name: string,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      postalCode?: string | null,
      accountType?: AccountType | null,
      accountStatus?: AccountStatus | null,
      accountSize?: AccountSize | null,
      customerId?: string | null,
      users?:  {
        __typename: "ModelUserConnection",
        nextToken?: string | null,
      } | null,
      classes?:  {
        __typename: "ModelClassConnection",
        nextToken?: string | null,
      } | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        nextToken?: string | null,
      } | null,
    },
    userId: string,
    activityDate: string,
    activityType: ActivityType,
    objectId: string,
    values?: string | null,
  } | null,
};
